// Copyright (c) Docugami, Inc. All rights reserved.

import { createApi } from "@reduxjs/toolkit/query/react";
import { Config } from "config";
import { ProviderAuthenticationId } from "networking/StorageProviders";
import { createDgBaseQuery } from "store/baseQuery";

type ProviderToken = {
    id: string;
    url: string;
    type: ProviderAuthenticationId;
    oauthAuthenticationId: string;
    account: {
        id: string;
        user: string;
    };
    updatedAt: string;
    createdAt: string;
};

type ConnectionsResponse = {
    connections: ProviderToken[];
};

export type AvailableOAuthProviders =
{
    providerId: string;
    displayName: string;
    description: string;
    iconSrc: string;
}

const baseQuery = createDgBaseQuery(`${Config.apiUrl}`);

export const storageConnectionsApiSlice = createApi({
    reducerPath: "storageConnectionsApi",
    baseQuery: baseQuery,
    tagTypes: ["StorageConnection"],
    endpoints: (builder) => ({
        getConnections: builder.query<ConnectionsResponse, void>({
            query: () => ({
                url: "/storage/connections?type=OAuth",
                method: "GET",
            }),
            providesTags: ["StorageConnection"],
        }),
        deleteConnection: builder.mutation<void, string>({
            query: (connectionId: string) => ({
                url: `/storage/connections/${connectionId}`,
                method: "DELETE",
            }),
            invalidatesTags: ["StorageConnection"],
        }),
        getOAuthProviders: builder.query<AvailableOAuthProviders[], void>({
            query: () => ({
                url: "/storage/connections/oauth/providers",
                method: "GET"
            })
        })
    }),
});

export const { useGetConnectionsQuery, useDeleteConnectionMutation, useGetOAuthProvidersQuery} = storageConnectionsApiSlice;
